"use client";

import classNames from "classnames";

const SwiperButton = ({ className, next = false, prev = false, ...rest }) => {
  return (
    <button
      {...rest}
      className={classNames("arrow-btn", {
        prev: prev,
        next: next,
        [className]: true,
      })}
    ></button>
  );
};

export default SwiperButton;
